import Vue from 'vue'
import VueCookies from 'vue-cookies'
import VueTelInput from 'vue-tel-input'
import VueSocketIO from 'vue-socket.io-extended'
import { io } from 'socket.io-client'
import App from './App.vue'
import G2Dialog from './plugins/g2dialog'
import router from './router'
import store from './store'

Vue.config.productionTip = false

Vue.use(VueTelInput)

Vue.use(VueCookies)

Vue.use(G2Dialog)

// CBTODO -- This will be different in the dev environment. Can we make this easier across environments?
var socket_connection = location.origin
// const socket_connection = 'localhost:5000'

const io_instance = io(socket_connection + "/chat", {
  withCredentials: false,
  autoConnect: false
})

Vue.use(VueSocketIO, io_instance, {
  store,
  actionPrefix: 'SOCKET_',
  mutationPrefix: 'SOCKET_',
  options: {
    useConnectionNamespace: true
  }
})

// router.afterEach(() => {
//   store.dispatch('getActiveAlertEvent')
// })

if (typeof Notification !== "undefined") {
  if (Notification.permission === "default" || Notification.permission === "denied") {
    Notification.requestPermission();
  }
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
